import { StaticImport } from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import TitleH3 from "./fonts/TitleH3";
import MainLink from "./navigation/MainLink";

interface HeroSectionProps {
  image: string | StaticImport;
  alt: string;
  tab: string;
  title: string;
  text: string;
  linkTitle: string;
  href: string;
  width?: number;
  height?: number;
}

const HeroSection = ({ ...props }: HeroSectionProps) => {
  return (
    <div className="from-background to-primary bg-gradient-to-t">
      <div className="gs--page-column py-15">
        <div className="flex flex-col-reverse items-center gap-10 sm:flex-row sm:justify-between sm:gap-5">
          <Image
            src={props.image}
            alt={props.alt}
            loading="lazy"
            width={props.width}
            height={props.height}
          />
          <div className="flex flex-col items-start gap-5">
            <TitleH3 className="text-white" title={props.title} />
            <span className="text-white">{props.text}</span>
            <MainLink href={props.href} title={props.linkTitle} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
